<template>
  <div class="housewarming-page">
    <h1>🎂</h1>
    <h1>Happy Birthday</h1>
    <h1>To Me</h1>
    <!-- <div class="container"> -->
    <img src="../assets/23-birthday.jpg" class="housewarming-header" title="Me being 31!"/>
    <!-- </div> -->
    <h1>🗓️14/09/24🗓️</h1>
    <h1>🎂</h1>
    <h1>I'm Getting Old!</h1>
    <h1>🎉</h1>
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <p>In September I am delighted to be turning <i>AN AGE</i><a href="#myagefoot" id="myageref"><sup>1</sup></a>!</p> 
        <p>I would love for you to come celebrate with us in our home in Kent on <b>Saturday the 14th of September</b>.</p>
        <h1>⏰</h1>
        <p>Show up anytime from 1pm.</p>
        <!-- <p>Pro tip: all the cool kids will show up at {{ generateCoolKidTime() }}.</p> -->
        <h1>🍕</h1>
        <p>We will provide Gluten Free and Veggie/Vegan food, feel free to bring snacks and food yourself, if you would like.</p>
        <h1>🥂</h1>
        <p>We will provide alcoholic and non-alcoholic drinks, feel free to bring your own too, if you would like.</p>
        <h1>🚂 🚘</h1>
        <p>Our closest station is Folkestone Central (10 min walk).</p>
        <p>There is free (time limited) parking near us and plenty of parking in town.</p>
        <h1>🏖️</h1>
        <p>We are a short walk from the beach! Feel free to explore the area and come and go as you please obvs.</p>
        <div class="container">
          <h2 class="centered">See you Soooon x</h2>
          <img src="../assets/Cake-Cut.jpeg" class="housewarming-footer" title="Cake is repsentative of possible future cake!"/>
        </div>
        <p id="myagefoot"><a href="#myageref"><sup>1</sup></a> One year older than last year of course!</p>
      </div>
      <div class="sml-col"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Birthday24',
    methods: {
      generateCoolKidTime() {
        var hour = Math.floor(Math.random() * 24).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          });
        var min = Math.floor(Math.random() * 60).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          });
        return `${hour}:${min}`;
      }
    }
  }
</script>
<style scoped>
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1 }
  }  
  .housewarming-page {
      text-align: center;
      font-size: 16px;
    }
  .housewarming-header {
    height: 100%;
    width: 90%; 
    -webkit-mask-image: linear-gradient(to top, black 75%, transparent 100%);
    mask-image: linear-gradient(to top, black 75%, transparent 100%);
    animation: fadeIn 1.7s;
  }

  .housewarming-footer {
    width: 90%; 
    height: 100%;
  }

  h1 {
    font-size: 2em;
    text-align: center;
    margin-left: 3px;
    margin-right: 3px;
    color: #2061b7;
    display: block;
    font-family: 'Press Start 2P', cursive;
  }

  h2 {
    font-size: 1em;
    color: #2061b7;
    text-align: center;
    display: block;
    font-family: 'Press Start 2P', cursive;
  }

   .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 40%;
  }

  .flex-grid-thirds .sml-col {
    width: 10%;
    text-align: left;
  }
  .container {
    position: relative;
    text-align: center;
    color: white;
  }
  .centered {
    position: absolute;
    left: 20%;
    top: 20%;
  }
</style>
